import { useMemo, type ReactNode } from "react";
import { lineChartSpec, type LineChartSpecOptions } from "../specs/line.js";
import type { ChartData } from "../types.js";
import { VegaChart } from "./VegaChart.js";
import type { ChartContainerProps } from "./shared.js";

export interface LineChartProps
  extends LineChartSpecOptions, ChartContainerProps {
  data: ChartData;
}

/** A themed line chart. Pass `color` for multiple series. */
export function LineChart({
  data,
  x,
  y,
  xType,
  yType,
  color,
  colorType,
  point,
  interpolate,
  xTitle,
  yTitle,
  title,
  subtitle,
  ...container
}: LineChartProps): ReactNode {
  const spec = useMemo(
    () =>
      lineChartSpec({
        data,
        x,
        y,
        xType,
        yType,
        color,
        colorType,
        point,
        interpolate,
        xTitle,
        yTitle,
        title,
        subtitle,
      }),
    [
      data,
      x,
      y,
      xType,
      yType,
      color,
      colorType,
      point,
      interpolate,
      xTitle,
      yTitle,
      title,
      subtitle,
    ],
  );

  return <VegaChart spec={spec} {...container} />;
}
